import { render, staticRenderFns } from "./ArtigosMainList.vue?vue&type=template&id=24dc7c4c&scoped=true&"
import script from "./ArtigosMainList.vue?vue&type=script&lang=js&"
export * from "./ArtigosMainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dc7c4c",
  null
  
)

export default component.exports